import {Urls} from "component/const/Urls";
import {Route, Routes} from "react-router-dom";
import {GiveFeedback} from "./pages/GiveFeedback";
import {FeedbackRes} from "./pages/FeedbackRes";
import {FeedbackReq} from "./pages/FeedbackReq";

export const Feedback = () => {
    return (<>
        <Routes>
            <Route index Component={GiveFeedback}/>
            <Route path={Urls.res} Component={FeedbackRes}/>
            <Route path={Urls.req} Component={FeedbackReq}/>
        </Routes>
    </>)
}